import { MutationTree } from "vuex";
import { ServiceProfileState, ServiceProfile } from "./model";

const mutations: MutationTree<ServiceProfileState> = {
  setServiceProfiles(state, serviceProfiles: ServiceProfile[]) {
    state.serviceProfiles = serviceProfiles
  },
  addServiceProfile(state, serviceProfile: ServiceProfile) {
    state.serviceProfiles.push(serviceProfile);
  },
  updateServiceProfile(state, serviceProfile: ServiceProfile) {
    const c = state.serviceProfiles.find(c => c.id === serviceProfile.id);
    Object.assign(c, serviceProfile);
  },
  deleteServiceProfile(state, id: string) {
    state.serviceProfiles = state.serviceProfiles.filter(serviceProfile => serviceProfile.id !== id);
  }
}

export default mutations;
